import React from "react";
import PropTypes from "prop-types";

import { BRANDSLIST } from "npmlinks-constants";
import { GridColumn, Img } from "arv-reactcomponents";
import Anchor from "../../../component/Anchor";
import { imageFileName } from "../../../utils";

const TrendingBannerComponent = props => {
  const { banner, bannerSlotClassName, bannerImgClassName } = props;
  if (banner) {
    return (
      <GridColumn
        className={`nwc-grid-col-sm ${bannerSlotClassName}`}
        key={banner.brandId}
      >
        <Anchor.component
          to={
            banner.url
              ? BRANDSLIST.HREF_SUFFIX.concat(banner.url)
              : banner.productListingUrl
          }
          href={
            banner.url
              ? BRANDSLIST.HREF_SUFFIX.concat(banner.url)
              : banner.productListingUrl
          }
          target="_blank"
        >
          {banner && banner.images && banner.images.logo ? (
            <Img
              className={bannerImgClassName}
              src={banner.images.logo}
              alt={imageFileName(banner.images.logo)}
            />
          ) : null}
        </Anchor.component>
      </GridColumn>
    );
  }
  return null;
};

TrendingBannerComponent.propTypes = {
  banner: PropTypes.shape({
    productListingUrl: PropTypes.string,
    images: PropTypes.shape({
      logo: PropTypes.string,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  bannerImgClassName: PropTypes.string.isRequired,
  bannerSlotClassName: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: TrendingBannerComponent,
  component: TrendingBannerComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/TrendingBannerComponent/index.js